<script setup>
import EventTable from '@frontJs/components/tables/projectManagement/sem/EventTable.vue';
import TenantReportEventTable from '@frontJs/components/tables/projectManagement/sem/tenantReports/EventTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Événements - SEM - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEM - Événements
    </PageTitle>

    <EventTable v-if="tenant" :tenant="tenant" />

    <TabLayout
        v-else
        :tabs="{
            all: {
                title: 'Tous',
                content: h(EventTable, { all: true }),
            },
            perCustomer: {
                title: 'Par client',
                content: h(TenantReportEventTable),
            },
        }"
    />
</template>
